var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.old)?_c('Old'):_c('New')],1)}
var staticRenderFns = []

export { render, staticRenderFns }